import { Divider, IconButton, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import FamilyRelationsTable from './FamilyRelationsTable';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGetAllLanguages } from '../../../api/articles';
import LanguageSelect from '../../selectTranslation/translateSelect';

const FamilyRelationsSettings = () => {
  const navigate = useNavigate();
  const { data: languages } = useGetAllLanguages();
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }} minHeight="100vh">
      <Box display="flex" flexDirection="column" width="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center" px={4}>
          <IconButton onClick={() => navigate(-1)} sx={{ marginLeft: -2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" fontWeight={700} px={5} py={2.45} sx={{ marginLeft: -4, flexGrow: 1 }}>
            {t('FamilyRelationSettings')}
          </Typography>
          <LanguageSelect />
        </Box>
        <Divider />
        <Box display="flex" flexDirection="column">
          <FamilyRelationsTable languages={languages} />
        </Box>
      </Box>
    </Box>
  );
};

export default FamilyRelationsSettings;
